/**
 * Vrai si `value` n'a pas plus de `maxDecimals` décimales.
 *
 * Robuste à la représentation flottante IEEE-754 : on ne peut PAS utiliser
 * `Math.round(v * 100) === v * 100` car `8.2 * 1000 === 8199.999999999999`
 * (et `0.07 * 100 === 7.000000000000001`), ce qui rejette des montants/tonnages
 * pourtant parfaitement valides. `toFixed` arrondit en base 10 sur la vraie
 * valeur décimale, donc le round-trip est fiable pour les plages métier
 * (montants MRU jusqu'au milliard, tonnages à 3 décimales).
 *
 * @example
 *   hasMaxDecimals(8.2, 3)          → true
 *   hasMaxDecimals(0.07, 2)         → true
 *   hasMaxDecimals(1234567.89, 2)   → true
 *   hasMaxDecimals(8.2005, 2)       → false
 */
export function hasMaxDecimals(value: number, maxDecimals: number): boolean {
  if (!Number.isFinite(value)) return false;
  return Number(value.toFixed(maxDecimals)) === value;
}
